export var issueInMonographs = function (issue) {
    var _a = issue, agenda = _a.agenda, linkedMonographTitleId = _a.linkedMonographTitleId;
    if (agenda !== "MONOGRAPHS" || issue.continuedFromPreviousVolume) {
        return null;
    }
    return linkedMonographTitleId ? "linked" : "own";
};
// the link is global: every library sees the issue is published as a monograph, whoever handles it
export var isMonographicIssue = function (issue) {
    var linkedMonographTitleId = issue.linkedMonographTitleId;
    return !!linkedMonographTitleId && !issue.continuedFromPreviousVolume;
};
export var issueHandledInMonographs = function (issue) {
    return issue.agenda === "MONOGRAPHS";
};
